var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.internal_component_desc")) +
                "\n    "
            ),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "internalComponentsConfigGroupsRegex",
              label: _vm.$t("admin.namespace_regex"),
              "input-group-size": "mb-3",
              type: "text",
              tooltip: _vm.$t("admin.namespace_regex_desc"),
            },
            model: {
              value: _vm.namespaceRegex,
              callback: function ($$v) {
                _vm.namespaceRegex = $$v
              },
              expression: "namespaceRegex",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "internalComponentsConfigNamesRegex",
              label: _vm.$t("admin.name_regex"),
              "input-group-size": "mb-3",
              type: "text",
              tooltip: _vm.$t("admin.name_regex_desc"),
            },
            model: {
              value: _vm.nameRegex,
              callback: function ($$v) {
                _vm.nameRegex = $$v
              },
              expression: "nameRegex",
            },
          }),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.identifyInternalComponents },
            },
            [_vm._v(_vm._s(_vm.$t("admin.perform_identification")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }